import React, { useEffect, useState } from "react";
import styles from "../../css/SmsDownloadReport.module.css";
import { Box } from "@mui/material";
import { apiList } from "../../helpers/apiList";
import { axiosPostApi } from "../../helpers/interceptorServices";
import CustomAlert from "../../helpers/CustomAlert";
import { useSelector } from "react-redux";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import Loader from "../Loader/Loader";
import MasterTable from "../common/MasterTable";

const SmsDownloadReport = ({ handleopenSmsDown, handleCloseSmsDown }) => {
  const { user } = useSelector((state) => state.auth);
  const userRole = sessionStorage.getItem("userRole");

  const [loading, setLoading] = useState(false);
  const [SMSDownloadData, setSMSDownloadData] = useState([]);
  const [noData, setNoData] = useState(false);
  const [pageDetails, setPageDetails] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const SMSDownloadHeaders = [
    "Request ID",
    ...(userRole !== "CUST" ? ["Report Type"] : []),
    "Req Date & Time",
    "From Date",
    "To Date",
    "Status",
    "File",
  ];

  const SMSDownloadHeaderToKeyMap = {
    "Request ID": "id",
    ...(userRole !== "CUST" ? { "Report Type": "reportType" } : {}),
    "Req Date & Time": "createdDate",
    "From Date": "reqFromDate",
    "To Date": "reqToDate",
    Status: "status",
    File: "downloadUrl",
  };

  useEffect(() => {
    downloadReport(1);
  }, []);

  const downloadReport = async (currentPage) => {
    setLoading(true);
    setNoData(false);

    try {
      const requestBody = {
        username: user?.data?.username,
      };

      const response = await axiosPostApi(
        `${apiList.SMS_DOWNLOAD_HISTORY}?&pageSize=${pageSize}&pageNo=${currentPage}`,
        requestBody
      );

      if (response && response.data) {
        if (response.data.status === true && response.data.respCode === "00") {
          const downloadHistory = response.data.data;
          setPageDetails(response.data.pageDetails);
          setSMSDownloadData(downloadHistory || []);

          if (!downloadHistory || downloadHistory.length === 0) {
            setNoData(true);
          } else {
            setNoData(false);
          }
        } else {
          setSMSDownloadData([]);
          setNoData(true);

          CustomAlert({
            title: "Failed",
            text: response.data.message || "Failed to fetch data",
            icon: "error",
            confirmButtonText: "Retry",
          });
        }
      } else {
        setSMSDownloadData([]);
        setNoData(true);
      }
    } catch (error) {
      console.error("Error fetching download history:", error);
      setSMSDownloadData([]);
      setNoData(true);

      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      setLoading(false);
    }
  };

  const pageSizeCount = pageDetails?.pageSize || 0;
  const totalRecord = pageDetails?.totalRecords || 0;

  return (
    <Box component="form">
      <div className={styles.modalOverlay}>
        <div className={styles.modalBox}>
          {/* Header */}
          <div className={styles.modalHeader}>
            <h2 className={styles.modalTitle}>Download Report</h2>
            <button onClick={handleCloseSmsDown} className={styles.closeButton}>
              <HighlightOffIcon />
            </button>
          </div>

          {/* Content */}
          <div className={styles.DownModalContent}>
            {loading ? (
              <Loader />
            ) : (
              <MasterTable
                headers={SMSDownloadHeaders}
                data={SMSDownloadData}
                filterFields={["id"]}
                entityType="SMS Download Report"
                headerToKeyMap={SMSDownloadHeaderToKeyMap}
                loading={loading}
                pageDetails={pageDetails}
                noData={noData}
                currentPage={currentPage}
                pageSize={pageSizeCount}
                totalRecord={totalRecord}
                fetchNextData={downloadReport}
                setCurrentPage={setCurrentPage}
                hideAction="hideAction"
              />
            )}
          </div>
        </div>
      </div>
    </Box>
  );
};

export default SmsDownloadReport;
